import { render, staticRenderFns } from "./social-detail.vue?vue&type=template&id=fe235e42&scoped=true"
import script from "./social-detail.vue?vue&type=script&lang=ts"
export * from "./social-detail.vue?vue&type=script&lang=ts"
import style0 from "./social-detail.vue?vue&type=style&index=0&id=fe235e42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe235e42",
  null
  
)

export default component.exports